// Remembers, across the round trip through Auth0's logout, that the visitor just signed
// out — so RequireAuth shows a "Signed out" screen instead of immediately starting a new
// login. Without this, an identity provider that keeps its own session (Test-IdP does)
// silently logs the same account straight back in, which defeats signing out — and
// loops back to the error screen if that account is the one being denied.
//
// sessionStorage: per-tab, survives the same-tab redirect, gone when the tab closes.
// Every access is guarded — storage can be unavailable (blocked cookies, some private
// modes), and then signing out simply behaves as it did before.

const KEY = "capability-registry:signed-out";

/** Called just before handing off to Auth0's logout, so the page Auth0 returns to shows
 * "Signed out" rather than starting a new login. */
export function markSignedOut(): void {
  try {
    sessionStorage.setItem(KEY, "1");
  } catch {
    // storage unavailable — fall back to the old behavior
  }
}

/** Whether this tab's last action was signing out — RequireAuth's cue to show the
 * "Signed out" screen instead of redirecting to Auth0. */
export function isSignedOut(): boolean {
  try {
    return sessionStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

/** Forgets the sign-out once the visitor logs in again (or asks to), so later visits go
 * straight to login as usual. */
export function clearSignedOut(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // nothing to clear
  }
}
